import React from "react";
import {useTranslation} from "react-i18next";
import {PrimaryButton} from "./PrimaryButton";

export function SaveButton(props: {
  disabled?: boolean,
}) {
  const {t} = useTranslation();
  return (
    <PrimaryButton type={"submit"} disableElevation={true} disabled={props.disabled} title={t('buttons.save')}/>
  )
}
